import { docodeHexResponse } from "../../_common/common.utils";
import viewBusinessDetailsTypes from "./viewBusiness.types";
const INITIAL_STATE: any = {
  searchBusinessDetailsResponse: null,
  searchBusinessDetailsResponseArr: [],
};

const viewBusinessReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_SUCCESS:
      return {
        ...state,
        searchBusinessDetailsResponse: action.payload,
        searchBusinessDetailsResponseArr: docodeHexResponse(
          action.payload,
          "GetBusinessDetailsKey",
        ),
      };

    case viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_FAILURE:
      return {
        ...state,
        searchBusinessDetailsResponse: action.payload,
        searchBusinessDetailsResponseArr: [],
      };

    case viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_CHANGED:
      return { ...state, searchBusinessDetailsResponse: null };
    default:
      return state;
  }
};

export default viewBusinessReducer;
